module.exports = __webpack_public_path__ + "img/noDatas.c865d372.png";